import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "messagesFilled"
const MessagesFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M21 3.375C21.621 3.375 22.125 3.879 22.125 4.5V16.5C22.125 17.121 21.621 17.625 21 17.625H12.489L7.54 20.923C7.043 21.255 6.375 20.898 6.375 20.3V17.625H3C2.379 17.625 1.875 17.121 1.875 16.5V4.5C1.875 3.879 2.379 3.375 3 3.375zM6.75 11.25V12.75H12.75V11.25zM6.75 7.125V8.625H17.25V7.125z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default MessagesFilledIcon
